// Généré par maquettes/outils/dc2react.py à partir de la maquette. Ne pas modifier à la main :
// changer maquettes/src puis relancer le script.
import React from 'react';

export default function SiteHeader({ v }) {
  return (
    <header style={{ position: "sticky", top: "0", zIndex: "50", background: "rgba(255, 255, 255, 0.96)", backdropFilter: "saturate(1.4) blur(8px)", borderBottom: "1px solid #E3E5E8" }}>
      <nav style={{ maxWidth: "1240px", margin: "0 auto", padding: "12px 24px", display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "space-between", gap: "16px" }}>
        <a href="/" style={{ display: "flex", alignItems: "baseline", gap: "10px", textDecoration: "none", color: "#15171A" }}>
          <span style={{ fontWeight: "800", fontSize: "22px", fontStretch: "88%", letterSpacing: "-0.01em" }}>
            Autoria
          </span>
          <span className="m-hide" style={{ fontFamily: "'IBM Plex Mono', ui-monospace, monospace", fontSize: "12px", color: "#5A6068" }}>
            outils internes e-commerce
          </span>
        </a>
        <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: "8px 24px", fontSize: "15px" }}>
          <a className="m-hide" href="/#equipes" style={{ color: "#15171A", textDecoration: "none" }}>
            Équipes
          </a>
          <a className="m-hide" href="/#offres" style={{ color: "#15171A", textDecoration: "none" }}>
            Offres
          </a>
          <a className="m-hide" href="/#methode" style={{ color: "#15171A", textDecoration: "none" }}>
            Méthode
          </a>
          <a className="m-hide" href="/#faq" style={{ color: "#15171A", textDecoration: "none" }}>
            FAQ
          </a>
          <a className="m-hide" href="/outils" style={{ color: "#15171A", textDecoration: "none" }}>
            Outils gratuits
          </a>
          <a className="m-hide" href="/partenaires" style={{ color: "#15171A", textDecoration: "none" }}>
            Nos partenaires
          </a>
          <a className="m-hide" href="/about" style={{ color: "#15171A", textDecoration: "none" }}>
            À propos
          </a>
          <a href="https://calendly.com/hello-autoria/30min?utm_source=autoria.dev&utm_medium=site&utm_content=entete" target="_blank" rel="noopener" className="lift" style={{ display: "inline-flex", alignItems: "center", minHeight: "44px", boxSizing: "border-box", padding: "10px 18px", background: "#FFFFFF", color: v.accent, border: `1.5px solid ${v.accent}`, textDecoration: "none", fontWeight: "700", borderRadius: "4px" }}>
            Réserver un appel
          </a>
        </div>
      </nav>
    </header>
  );
}
